import { Field } from '@base-ui/react/field';
import type { ComponentProps } from 'react';
import { Input } from '@/components/ui/Input';
import { cn } from '@/lib/utils';

const labelClass = 'text-sm lg:text-base font-medium text-foreground';

export interface TextFieldProps extends ComponentProps<typeof Input> {
  hint?: string;
  label: string;
  mono?: boolean;
  onValueChange: (value: string) => void;
}

export const TextField = ({
  className,
  hint,
  label,
  mono,
  onValueChange,
  value = '',
  ...props
}: TextFieldProps) => (
  <Field.Root className={cn('block', className)}>
    <div className="mb-1.5 flex items-baseline justify-between">
      <Field.Label className={labelClass}>{label}</Field.Label>
      {hint && (
        <Field.Description className="font-mono text-xs lg:text-sm text-subtle">
          {hint}
        </Field.Description>
      )}
    </div>
    <Input
      font={mono ? 'mono' : 'sans'}
      onChange={(e) => onValueChange(e.target.value)}
      size="sm"
      {...props}
    />
  </Field.Root>
);
